var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"hall-event-mini-tile",on:{"click":function($event){return _vm.showPopUp()}}},[_c('img',{attrs:{"src":_vm.imageSrc}}),_c('h3',{staticClass:"hall-event-mini-tile-h3"},[_vm._v(_vm._s(_vm.eventObj.event_title))])])}
var staticRenderFns = []

export { render, staticRenderFns }